/* Command Dialog Container */
.commandDialogContainer .ant-modal-content {
  background-color: #f7f7f7;
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
}

.commandDialogContainer :global(.ant-modal-body) {
  padding: 0 20px !important;
}

/* Close Icon Placement */
.commandDialogContainer .ant-modal-close {
  top: 24px;
  right: 24px;
  width: auto;
  height: auto;
  color: #333;
}

/* Modal Title */
.modalTitle {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #04051b; /* Dark text color */
}

/* Modal Subtitle/Description */
.modalSubtitle {
  font-size: 1rem;
  color: #525252; /* Slightly lighter text color */
  margin: 0;
  font-weight: 400;
}

/* Done Button Style */
.doneButtonCustom {
  height: 52px; /* Large button height */
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  width: 100%; /* Full width button */
  margin-top: 24px;
  background-color: #ffa100; /* Custom gray color from the image */
  border-color: #ffa100;
  color: #04051b;
}

.doneButtonCustom:hover {
  background-color: #ffba42 !important;
  border-color: #ffba42 !important;
  color: #04051b !important;
}

.cancelButtonCustom {
  height: 52px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  margin-top: 24px;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #525252;
  --ant-button-default-active-border-color: #e0e0e0;
  --ant-button-default-active-color: #525252;
}

.cancelButtonCustom:active {
  --ant-button-default-active-border-color: #525252;
  --ant-button-default-active-color: #525252;
}

.cancelButtonCustom:hover {
  background-color: #d4d4d4 !important;
  border-color: #d4d4d4 !important;
  color: #333 !important;
}

@media (max-width: 575.98px) {
  .commandDialogContainer :global(.ant-modal-container) {
    padding: 24px 16px;
  }
}
